// Sentry error tracking — client crash reporting for prod.
//
// Same key-gated pattern as analytics.ts: no VITE_SENTRY_DSN → every call is
// a no-op, so dev machines and PRs without a DSN configured never try to
// report anywhere. Source maps are emitted by vite.config.ts's build config
// so stack traces resolve to real file/line instead of minified bundle
// offsets; uploading them to Sentry (so it can de-minify server-side) is a
// separate step done via @sentry/vite-plugin once SENTRY_AUTH_TOKEN/ORG/
// PROJECT are available — see vite.config.ts.

import * as Sentry from '@sentry/react'

let enabled = false

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Conservative default — this is a cost lever, not just a knob. Revisit
    // once real traffic volume post-launch tells us what's affordable.
    tracesSampleRate: 0.1,
  })

  enabled = true
}

/** Safe report — no-op until initSentry has run with a DSN. */
export function reportError(error: unknown, context?: Record<string, unknown>) {
  if (!enabled) {
    // Still visible in the console locally / when no DSN is configured.
    console.error(error, context)
    return
  }
  Sentry.captureException(error, context ? { extra: context } : undefined)
}
